import { useState } from "react"
import { ChevronDown } from "lucide-react"
import RestInfo from "./RestInfo"

export default function MenuCard({menuItems,foodselected}){

    const [isOpen, setIsOpen] = useState(true);


    if("categories" in menuItems){
        return(
            <div className="w-full">
            <p className="font-display text-2xl font-semibold text-charcoal">{menuItems.title}</p>
            <div>
                {
                    menuItems?.categories?.map((items)=> <MenuCard key={items?.title} menuItems={items} foodselected={foodselected}></MenuCard>)
                }
            </div>
            </div>
        )
    }

    let itemCards = menuItems?.itemCards;
    if(foodselected==='veg') itemCards = itemCards?.filter((food)=> "isVeg" in food?.card?.info);
    if(foodselected==='nonveg') itemCards = itemCards?.filter((food)=> !("isVeg" in food?.card?.info));

    return (
        <div className="w-full mb-6">
            <button
                className="flex items-center justify-between w-full mb-4 text-left"
                onClick={()=>setIsOpen(!isOpen)}
            >
                <p className="font-display text-2xl font-semibold text-charcoal">{menuItems.title}</p>
                <ChevronDown className={`w-6 h-6 text-charcoal/60 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`} />
            </button>
            {
                isOpen &&
                <div>
                    {
                        itemCards?.map((items)=><RestInfo key={items?.card?.info?.id} restData = {items?.card?.info}></RestInfo>)
                    }
                </div>
            }
            <div className="h-px bg-charcoal/15 mt-2"></div>
        </div>
    )
}